import { CircularProgress } from '../mui';

const ProgressCircular = () => {
	const styles = {
		position: 'fixed',
		top: '50%',
		left: '50%',
	};

	return <CircularProgress sx={styles} size={50} />;
};

export default ProgressCircular;
